import { makeStyles } from "@material-ui/core/styles";
export const useListSubheaderStyles = makeStyles({
    root: {
        fontSize: '1.1rem'
    }
});
